import { deriveSequence, VN_DGA_CONFIG } from '@skyground/vn-dga'

/**
 * Derive `count` consecutive DGA domain candidates starting at `startIndex`, in the order the
 * client should probe them. This is a thin, intent-named wrapper over the shared DGA so the
 * client uses the exact same frozen production parameters (`VN_DGA_CONFIG`) as the vn-access
 * origin — the two sides must derive an identical sequence or discovery can never converge.
 *
 * The window is deliberately bounded: the client probes a handful of the currently-registered
 * domains rather than an unbounded sweep. The caller persists the winning index (from the signed
 * beacon) so the next cold start resumes near the live position instead of from zero.
 */
export const generateCandidateDomains = (startIndex: number, count: number): string[] =>
  deriveSequence(startIndex, count, VN_DGA_CONFIG)
